import { css } from 'styled-components';
import { CFBaseStepperHelpers } from './styles';
import { CFTokens } from '../../tokens';
export const CFBaseStepperStyles = {
    ButtonWrapper: css `
    padding: ${CFBaseStepperHelpers.buttonPadding};
  `,
    Input: css `
    padding: 0;
    left: 0;
    border: none;
  `,
    InputMobile: css `
    background-color: ${CFBaseStepperHelpers.focusedMobileBackground};
  `,
    InputText: css `
    font-size: ${CFBaseStepperHelpers.fontSize}px;
    font-weight: ${CFTokens.FONT_WEIGHT.BOLD};
  `,
    InputWeb: css `
    width: 100%;
    position: absolute;
    background-color: ${CFBaseStepperHelpers.focusedWebBackground};

    &:focus {
      outline: none;
    }

    /* Chrome, Safari, Edge, Opera */
    &::-webkit-inner-spin-button {
      display: none;
    }
  `,
    InputWrapper: css `
    display: flex;
    position: relative;
    align-items: center;
  `,
    Root: css `
    height: ${CFBaseStepperHelpers.rootHeight}px;
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: ${CFTokens.SPACER.B}px;
    border: 1px solid ${CFBaseStepperHelpers.focusedBorder};
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
  `,
    RootMobile: css `
    background-color: ${CFBaseStepperHelpers.focusedMobileBackground};
  `,
    RootWeb: css `
    width: fit-content;
    background-color: ${CFBaseStepperHelpers.focusedWebBackground};
  `,
};
